import * as styles from './GridLabels.css.ts';

const LETTERS = 'ABCDEFGHIJKL'.split('');

/** Chart-edge coordinate labels (A, B, C… along the top, 1, 2, 3… down the side). Decorative. */
export function GridLabels({ columns = 8, rows = 6 }: { columns?: number; rows?: number }) {
  return (
    <div className={styles.root} aria-hidden="true">
      <div className={styles.top}>
        {LETTERS.slice(0, columns).map((letter) => (
          <span key={letter}>{letter}</span>
        ))}
      </div>
      <div className={styles.side}>
        {Array.from({ length: rows }, (_, i) => (
          <span key={i}>{i + 1}</span>
        ))}
      </div>
    </div>
  );
}
